import {IAction} from "../model/IAction";
import {ITimeZoneEntry} from "../model/ITriggerData";

import * as FetchTimeZones from "../actions/FetchDataItems";

export function timeZones(state: ITimeZoneEntry[] = [], action: IAction): ITimeZoneEntry[] {
     switch (action.type) {
        case FetchTimeZones.RECEIVE_TIMEZONES:
            const receiveAction = action as FetchTimeZones.IReceiveTimeZoneAction;
            return receiveAction.timeZoneData;
        default:
            return state;
    }
}
